import { useState } from "react";
import type { RoleOption } from "../../../../shared/rbac/roles";
import { sameRoleOption } from "../../../lib/grantAssembly";
import { Button } from "../../Button";
import { Dropdown } from "../../Dropdown";
import { Icon } from "../../Icon";
import { Modal } from "../../Modal";
import { ModalContent, ModalFooter } from "../../ModalCard";
import { Text } from "../../Text";
import { DropdownOpener } from "../shared";

type Props = {
  title: string;
  description: string;
  confirmLabel: string;
  confirmReady: boolean;
  roleOptions: RoleOption[];
  onConfirm: (role: RoleOption) => void;
  onClose: () => void;
};

export function DropConfirmModal({
  title,
  description,
  confirmLabel,
  confirmReady,
  roleOptions,
  onConfirm,
  onClose,
}: Props) {
  const [role, setRole] = useState<RoleOption | undefined>(undefined);
  const roleOpener = (
    <DropdownOpener type="button" disabled={!confirmReady}>
      <Text
        variant="text-regular"
        ellipsis
        color={role ? "var(--text-primary)" : "var(--text-secondary)"}
      >
        {role?.label ?? "Select role"}
      </Text>
      <span style={{ opacity: 0.3 }}>
        <Icon name="chevron-down" size={12} />
      </span>
    </DropdownOpener>
  );

  return (
    <Modal open onClose={onClose} alert>
      <ModalContent style={{ width: 320 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <Text
            variant="text-regular-md"
            color="var(--text-primary)"
            style={{ textWrap: "pretty" }}
          >
            {title}
          </Text>
          <Text
            variant="text-regular"
            color="var(--text-secondary)"
            style={{ textWrap: "pretty" }}
          >
            {description}
          </Text>
        </div>
        {confirmReady ? (
          <Dropdown
            align="bottom-left"
            minWidth={288}
            opener={roleOpener}
            sections={[
              {
                items: roleOptions.map((opt) => ({
                  type: "button" as const,
                  left: undefined,
                  label: opt.label,
                  right:
                    role && sameRoleOption(role, opt) ? (
                      <Icon
                        name="check"
                        size={12}
                        color="var(--text-secondary)"
                      />
                    ) : undefined,
                  onClick: () => setRole(opt),
                })),
              },
            ]}
          />
        ) : (
          roleOpener
        )}
        <ModalFooter>
          <Button size="l" variant="subtle" onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="l"
            disabled={!confirmReady || !role}
            onClick={() => role && confirmReady && onConfirm(role)}
          >
            {confirmLabel}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
